import { groupBy as _groupBy } from 'lodash';

class ReportsController {
  constructor(authService, reportingService, loadingService) {
    "ngInject";

    if (!authService.isLoggedIn()) { return;};

    this.authService = authService;
    this.reportingService = reportingService;
    this.loadingService = loadingService;

    this.availableReports = [];
    this.loadReports();
  }

  loadReports() {
    this.loadingService.showLoading('reports', 'Loading Reports ...');

    this.reportingService.availableReportsByCategory(this.authService.authData.currentLocation.key, this.authService.getRole().roleId)
      .then(response => {
        this.availableReports = _groupBy(response.data, o => o.categoryName);        
      })
      .catch(err => {

      })
      .finally(() => {
        this.loadingService.hideLoading('reports');
      })
  }
}

export default ReportsController;



// WEBPACK FOOTER //
// ./client/app/components/reports/reports.controller.js